<template>
  <div class="w-full h-full">
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      class="w-full max-w-7xl mx-auto flex flex-col gap-4 h-full"
      v-if="dataval != null"
    >
      <div>
        <button
          @click="$router.go(-1)"
          class="bg-blues text-white px-4 font-semibold text-sm py-1 rounded-xl mt-10 mx-10"
        >
          Back
        </button>
      </div>

      <div class="overflow-y-auto pb-10">
        <div
          v-for="(el, index) in dataval.coursequizusersanswer_set"
          :key="el"
          class="border max-w-4xl mx-auto mt-4 text-start p-10 rounded-3xl"
        >
          <p class="py-2 font-bold">
            {{ index + 1 }}) {{ el.question.question_text }}
          </p>

          <div
            v-for="(al, index) in el.question.coursequizanswer_set"
            :key="al"
          >
            <p
              class
              :class="[al.is_correct == true ? 'text-blue-900 font-bold' : '']"
            >
              {{ index + 1 }}) {{ al.answer_text }}
              <br />
            </p>
          </div>

          <div
            v-if="el.question.choice_type === 'choice'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <h1
              class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
            >
              Your Answer :
            </h1>
            <p
              v-if="el.answer"
              class="px-4 text-sm font-bold mt-2"
              :class="[
                el.answer.is_correct == true
                  ? 'text-green-700'
                  : 'text-red-400',
              ]"
            >
              {{ el.answer.answer_text }}
            </p>
            <p v-else class="px-4 text-sm font-bold">Not attend</p>
          </div>

          <div
            v-if="el.question.choice_type === 'description'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <h1
              class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
            >
              Your Answer
            </h1>
            <p
              v-if="el.description != null"
              class="px-4 text-sm font-bold mt-2"
            >
              {{ el.description }}
            </p>
          </div>

          <div
            v-if="el.question.choice_type === 'shortdescription'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <h1
              class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
            >
              Your Answer
            </h1>
            <p
              v-if="el.short_description != null"
              class="px-4 text-sm font-bold mt-2"
            >
              {{ el.short_description }}
            </p>
          </div>
          <div
            v-if="el.question.choice_type === 'coding'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <div
              class="w-full bg-gray-900 text-white rounded-lg overflow-hidden"
            >
              <!-- Header -->
              <div
                class="flex justify-between items-center px-5 py-3 bg-gray-800 border-b border-gray-700"
              >
                <div class="flex items-center gap-4">
                  <h3 class="text-sm font-semibold">Code Editor</h3>
                  <input
                    type="text"
                    :value="el.question.programming_language"
                    class="px-3 py-1.5 border border-gray-700 rounded bg-gray-700 text-white text-xs outline-none cursor-not-allowed"
                    disabled
                  />
                </div>
              </div>

              <div class="flex" style="height: 400px">
                <!-- Left Side - Code Editor -->
                <div
                  class="flex-1 flex flex-col overflow-hidden border-r border-gray-700"
                >
                  <div
                    class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                  >
                    <span>📝 Submitted Code</span>
                  </div>

                  <MonacoEditor
                    :value="el.coding || '// No code submitted'"
                    :language="el.question.programming_language"
                    height="100%"
                    theme="vs-dark"
                    :options="{
                      readOnly: true,
                      minimap: { enabled: false },
                      scrollBeyondLastLine: false,
                      fontSize: 13,
                      lineNumbers: 'on',
                      glyphMargin: false,
                      lineDecorationsWidth: 0,
                      lineNumbersMinChars: 3,
                      renderLineHighlight: 'none',
                      contextmenu: false,
                      cursorStyle: 'line-thin',
                    }"
                    class="flex-1"
                  />
                </div>

                <!-- Right Side - Output -->
                <div class="flex-1 flex flex-col overflow-hidden">
                  <div
                    class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                  >
                    <span>📤 Output</span>
                  </div>
                  <div class="flex-1 p-4 overflow-y-auto bg-gray-900">
                    <div
                      v-if="el.output"
                      class="font-mono text-xs whitespace-pre-wrap leading-relaxed text-gray-300"
                    >
                      {{ formatOutput(el.output) }}
                    </div>
                    <div
                      v-else
                      class="text-gray-500 italic text-center mt-12 text-xs"
                    >
                      No output available
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div
                  class="flex flex-wrap justify-center gap-4 w-full"
                  v-if="el.question.choice_type == 'truefalse'"
                >
                  <button
                    style="border: 1px solid #01b0f9"
                    class="border rounded py-3 px-4 w-5/12 relative text-sm hover:bg-blue-900 hover:text-white"
                    :class="[
                      el.question.ansclk == option.id
                        ? 'bg-blue-900 text-white border-gray-400'
                        : '',
                    ]"
                    :key="index"
                    v-for="(option, index) in el.question
                      .coursequizanswer_set"
                    @click="handleAnswerClick(option.is_correct, option.id)"
                  >
                    {{ option.answer_text }}
                  </button>
                </div> -->

          <div
            class="flex flex-col flex-wrap justify-center gap-4 w-full"
            v-if="el.question.choice_type == 'matchthefollowing'"
          >
            <div class="grid grid-cols-2 gap-10 pt-5">
              <div class="flex flex-col gap-2">
                <div
                  v-for="left_items in el.match_answer.left_items"
                  :key="left_items"
                  class="text-sm px-5 py-2 bg-gray-100"
                >
                  Question: {{ left_items.value }}
                </div>
              </div>
              <draggable
                :list="el.match_answer.right_items"
                class="dragArea list-group w-full flex flex-col gap-2"
              >
                <div
                  v-for="right_items in el.match_answer.right_items"
                  :key="right_items"
                  class="text-sm px-5 py-2 bg-gray-200 cursor-pointer"
                >
                  {{ right_items.value }}
                </div>
              </draggable>
            </div>

            <br />
          </div>

          <!-- {{ el.question.choice_type }} -->

          <!-- {{ el }} -->

          <div class="flex items-center gap-2">
            <span v-if="el.question.max_mark != null"
              >Max Mark: {{ el.question.max_mark }}</span
            >

            <div
              v-if="el.question.max_mark != null"
              class="flex items-center gap-2"
            >
              <input
                type="number"
                :value="el.mark"
                class="getmark border py-1 px-2 rounded-lg"
                :id="'text' + el.id"
              />
              <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                <button
                  class="rounded-xl px-5 py-1.5 text-sm"
                  @click="addMarkPatch(el.id, el.question.max_mark)"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-primary cursor-pointer text-white'
                  "
                >
                  Update Mark
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src

import Header from "@/components/Instructor/Header.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";
import MonacoEditor from "monaco-editor-vue3";

// import router from "../../router";
export default {
  name: "testMCqview",
  data() {
    return {
      currentQuestion: 0,
      countDown: 840,
      showScore: false,
      questions: [],
      tst: false,
      score: 0,
      is_completed: false,
      is_submit: false,
      nextquz: 0,
      message: "",
      mcqset: "",
      dataval: null,
      answeredData: "",
      currentAnsweredQuestion: 0,
      messages: {
        text: "",
        type: "null",
      },
      disable_submit: false,
      // quiz_details: [],
      // currentQuizDetails: ""
    };
  },
  props: ["course_id", "quiz_id", "taker_id"],

  computed: mapGetters([
    "isAuthenticated",
    "userInfo",
    "profileInfo",
    "cartInfo",
    "courseTrackerInfo",
    "subscriptionInfo",
  ]),
  components: {
    FlashMessage,
    Header,
    Footer,
    MonacoEditor,
  },

  async created() {
    this.mcqCall();
    this.tst = false;
    this.countDownTimer();

    let token = this.userInfo.token_key;

    axios
      .get(
        `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.quiz_id}/?Key=${token}&id=${this.taker_id}`
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.dataval = response.data.data[0];
        }
        console.log("response:: test", response.data.message);
      });
  },

  mounted() {
    //
  },

  methods: {
    formatOutput(output) {
      try {
        ``;
        const outputArray = JSON.parse(output);

        return outputArray.join("\n");
      } catch (e) {
        return output;
      }
    },
    async addMarkPatch(id, max_mark) {
      this.disable_submit = true;
      //  await axios
      //   .patch(
      //     `${process.env.VUE_APP_API}/course-quiz-answer/${id}/?Key=${this.userInfo.token_key}`,
      //     { mark: document.getElementById(`text${id}`).value }
      //   )
      //   .then(response => {
      //     this.messages = {
      //       text: "Mark Updated.",
      //       type: "success"
      //     };
      //     this.getSUbmittedQuiz();
      //     setTimeout(() => {
      //       this.messages = {
      //         text: "",
      //         type: ""
      //       };
      //     }, 2000);
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });

      if (max_mark == null) {
        await axios
          .patch(
            `${process.env.VUE_APP_API}/course-quiz-answer/${id}/?Key=${this.userInfo.token_key}`,
            { mark: document.getElementById(`text${id}`).value }
          )
          .then((response) => {
            this.disable_submit = false;
            this.messages = {
              text: "Mark Updated.",
              type: "success",
            };
            this.getSUbmittedQuiz();
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        let markss = document.getElementById(`text${id}`).value;
        if (markss <= max_mark) {
          await axios
            .patch(
              `${process.env.VUE_APP_API}/course-quiz-answer/${id}/?Key=${this.userInfo.token_key}`,
              { mark: document.getElementById(`text${id}`).value }
            )
            .then((response) => {
              this.disable_submit = false;
              this.messages = {
                text: "Mark Updated.",
                type: "success",
              };
              this.getSUbmittedQuiz();
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "",
                };
              }, 2000);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.messages = {
            text: "Mark is less than the max mark.",
            type: "message",
          };
          this.getSUbmittedQuiz();
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        }
      }
    },

    async mcqCall() {
      // course_quizzes_pk
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/course_quizzes_pk/${this.quiz_id}/?Key=${token}`
        )
        .then((r) => {
          this.mcqset = r.data.data[0];
          console.log(this.mcqset.quiz.coursequizquestion_set);
          this.questions = r.data.data[0].quiz.coursequizquestion_set;

          if (this.questions) {
            this.questions.forEach((el) => {
              el.ansclk = "";
              el.anr = false;
            });
          }
        });
    },

    handleAnswerClick(isCorrect, id) {
      this.questions[this.currentQuestion].ansclk = id;
      this.questions[this.currentQuestion].anr = isCorrect;
      let nextQuestion = this.currentQuestion + 1;

      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    submitMcq() {
      this.showScore = true;
      localStorage.setItem("mcqTstv", true);
      this.tst = true;
    },
    nxtQt() {
      let nextQuestion = this.currentQuestion + 1;
      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;
      }
    },
    pvsQt() {
      if (this.currentQuestion > 0) {
        let nextQuestion = this.currentQuestion - 1;
        if ((nextQuestion) => 0) {
          this.currentQuestion = nextQuestion;
        }
      }
    },

    nxtQtSubmitted() {
      if (
        this.currentAnsweredQuestion <
        this.dataval.coursequizusersanswer_set.length
      ) {
        this.currentAnsweredQuestion = this.currentAnsweredQuestion + 1;
      }
      // let nextQuestion = this.currentQuestion + 1;
      // if (nextQuestion < this.questions.length) {
      //   this.currentQuestion = nextQuestion;
      // }
    },

    pvsQtSubmitted() {
      if (this.currentAnsweredQuestion > 0) {
        this.currentAnsweredQuestion = this.currentAnsweredQuestion - 1;
      }
      // if (this.currentQuestion > 0) {
      //   let nextQuestion = this.currentQuestion - 1;
      //   if ((nextQuestion) => 0) {
      //     this.currentQuestion = nextQuestion;
      //   }
      // }
    },

    // async quizPreview() {
    //   // this.is_popupview = true;
    //   let token = this.userInfo.token_key;
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.taker_id}/?Key=${token}`
    //     )
    //     .then((response) => {
    //       if (response.data.status == 200) {
    //         this.dataval = response.data.data;
    //       }
    //       console.log("response:: test", response.data.message);
    //     });
    // },

    // async quizPreview(id) {
    //   let token = this.userInfo.token_key;
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}`
    //     )
    //     .then((response) => {
    //       this.dataval = response.data.data;
    //       console.log("response::", response.data.data);
    //     });
    // },

    async getSUbmittedQuiz() {
      let token = this.userInfo.token_key;

      axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.quiz_id}/?Key=${token}&id=${this.taker_id}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.dataval = response.data.data[0];
            console.log(response.data.data, "response.data.data");
          }
          console.log("response:: test", response.data.message);
        });
    },

    async ckans() {
      var ans_set = [];
      let token = this.userInfo.token_key;
      this.questions.forEach((el) => {
        let val = {
          question: el.id,
          answer: el.ansclk,
          description: el.description,
          short_description: el.short_description,
        };
        ans_set.push(val);
        if (el.anr) {
          this.score += 1;
        }
      });

      this.HeaderVal = {
        score: this.score,
        quiz: this.mcqset.quiz.course,
        quiz_title: this.mcqset.quiz.name,
        usersanswer: ans_set,
        completed: true,
      };
      await axios
        .patch(
          `${process.env.VUE_APP_API}/course_save_multi_answer/?Key=${token}`,
          this.HeaderVal
        )
        .then((response) => {
          console.log("response", response);

          // this.quizPreview();

          if (response.data.status == 200) {
            this.messages = {
              text: "Quiz Submitted.",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              this.getSUbmittedQuiz();
              // console.log(response.data.data);
              // this.apiId = response.data.data;
              // this.taker_id = response.data.data;
              this.$emit("pushLessonComplete");
              // localStorage.setItem()
              // setTimeout(()=>{
              //   window.location.reload();
              // }, 500)
              //
            }, 2000);

            this.getSUbmittedQuiz();
          }
        });
    },
  },
};
</script>

<style scoped>
.gradient-btn {
  background: #0f172a;
  --tw-shadow: 0 10px 30px -3px rgba(255, 31, 57, 0.1),
    0 10px 30px -6px rgba(255, 31, 57, 0.3);
  transition: all 0.2s linear;
  color: white;
  border: 0px;
  padding: 8px 16px;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border-radius: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  min-width: 160px;
  font-weight: 700;
}

/* .gradient-btn:hover {
      background: radial-gradient(
        125.44% 4484.38% at 107.67% 116.67%,
        #0b08c4 0,
        #030166 100%
      );
      --tw-shadow: 0 10px 30px -3px rgba(255, 31, 57, 0.1),
        0 10px 30px -6px rgba(255, 31, 57, 0.3);
      color: white;
    } */

/* @media (min-width: 300px) and (max-width: 1024px) {
      .gradient-btn {
        background: radial-gradient(
          125.44% 4484.38% at 107.67% 116.67%,
          #030166 0,
          #0b08c4 100%
        );
        --tw-shadow: 0 10px 30px -3px rgba(255, 31, 57, 0.1),
          0 10px 30px -6px rgba(255, 31, 57, 0.3);
        transition: all 0.2s linear;
        color: white;
        border: 0px;
        padding: 8px 16px;
        font-size: 0.875rem;
        line-height: 1.25rem;
        outline: 2px solid transparent;
        outline-offset: 2px;
        border-radius: 0.25rem;
        font-weight: 700;
      }
    } */
</style>
